import { render, staticRenderFns } from "./Map2.vue?vue&type=template&id=2f8cba9b&scoped=true"
import script from "./Map2.vue?vue&type=script&lang=js"
export * from "./Map2.vue?vue&type=script&lang=js"
import style0 from "./Map2.vue?vue&type=style&index=0&id=2f8cba9b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8cba9b",
  null
  
)

export default component.exports